<template>
  <div
    ref="containerRef"
    class="container-filter-all"
    :class="allClass"
  >
    <div
      v-if="hasMain"
      ref="mainRef"
      class="container-filter-outer"
      :class="mainClass"
    >
      <div v-if="slots.main1" class="filter-content"><slot name="main1" /></div>
      <div v-if="slots.main2" class="filter-content"><slot name="main2" /></div>
      <div v-if="slots.main3" class="filter-content"><slot name="main3" /></div>
      <div v-if="slots.main4" class="filter-content"><slot name="main4" /></div>
    </div>

    <div
      v-if="hasSec"
      ref="secRef"
      class="container-filter-outer"
      :class="secClass"
    >
      <div v-if="slots.sec1" class="filter-content"><slot name="sec1" /></div>
      <div v-if="slots.sec2" class="filter-content"><slot name="sec2" /></div>
      <div v-if="slots.sec3" class="filter-content"><slot name="sec3" /></div>
      <div v-if="slots.sec4" class="filter-content"><slot name="sec4" /></div>
    </div>
  </div>
</template>

<script>
  /* eslint-disable */
  import { ref, computed, onMounted, onBeforeUnmount, watch, nextTick, watchEffect } from "vue"
  import { useStore } from "vuex"

  export default {
    name: "Container Filter",

    setup(props, { slots }) {
      const store = useStore()
      const isAsideMobileExpanded = computed(() => store.state.isAsideMobileExpanded)

      const containerRef = ref(null)
      const mainRef = ref(null)
      const secRef = ref(null)

      const containerWidth = ref(0)
      const mainWidth = ref(0)
      const secWidth = ref(0)

      const getWidthClass = (w) => {
        if (w >= 1200) return "xxl-length"
        if (w >= 1024) return "xl-length"
        if (w >= 800) return "l-length"
        if (w >= 600) return "m-length"
        if (w >= 480) return "s-length"
        return ""
      }

      const updateWidths = () => {
        if (containerRef.value) containerWidth.value = containerRef.value.offsetWidth
        if (mainRef.value) mainWidth.value = mainRef.value.offsetWidth
        if (secRef.value) secWidth.value = secRef.value.offsetWidth
      }

      let resizeObserver = null

      onMounted(() => {
        resizeObserver = new ResizeObserver(() => {
          updateWidths()
        })

        if (containerRef.value) resizeObserver.observe(containerRef.value)
        if (mainRef.value) resizeObserver.observe(mainRef.value)
        if (secRef.value) resizeObserver.observe(secRef.value)

        updateWidths()
      })

      onBeforeUnmount(() => {
        if (resizeObserver) resizeObserver.disconnect()
      })

      const hasMain = !!(slots.main1 || slots.main2 || slots.main3 || slots.main4)
      const hasSec = !!(slots.sec1 || slots.sec2 || slots.sec3 || slots.sec4)

      const mainCount = [slots.main1, slots.main2, slots.main3, slots.main4].filter(Boolean).length
      const secCount = [slots.sec1, slots.sec2, slots.sec3, slots.sec4].filter(Boolean).length

      const allClass = computed(() => [getWidthClass(containerWidth.value)])

      const mainClass = computed(() => [
        getWidthClass(mainWidth.value),
        {
          "has-content": hasMain && hasSec,
          "has-multiple": mainCount > 1,
          "has-single": mainCount === 1,
        },
      ])

      const secClass = computed(() => [
        getWidthClass(secWidth.value),
        {
          "has-content": hasMain && hasSec,
          "has-multiple": secCount > 1,
          "has-single": secCount === 1,
        },
      ])

      return {
        isAsideMobileExpanded,
        containerRef,
        mainRef,
        secRef,
        slots,
        hasMain,
        hasSec,
        mainCount,
        secCount,
        allClass,
        mainClass,
        secClass,
        mainWidth,
        secWidth
      }
    }
  }
</script>

<style lang="scss">
  .container-filter-all {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: start;
    // margin-bottom: 20px;

    .container-filter-outer {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: column;
      justify-content: start;
      gap: 16px;
      transition: width .5s;

      .filter-content {
        width: 100%;
        height: auto;
        display: grid;
        grid-template-columns: repeat(1, 1fr);
        gap: 16;

        .general-filter-content {
          width: 100%;

          p {
            width: 100%;
            height: auto;
            font-size: 14px;
            line-height: 20px;
          }

          .filter-inner {
            width: 100%;

            .form-comp {
              width: 100%;

              input,
              textarea,
              select {
                width: 100%;
                border: none !important;
                box-shadow: none !important;
                background-color: transparent !important;
                font-size: 14px !important;
                line-height: 20px !important;
                padding: 6px 8px !important;
                outline: 1px solid rgb(181, 180, 180) !important;
                outline-offset: -1px !important;

                &:focus {
                  outline: 1px solid rgb(0, 119, 255) !important;
                }
              }

              input,
              select {
                height: fit-content !important;
              }
            }
          }
        }
      }
    }

    .container-filter-outer.s-length {
      .filter-content {
        grid-template-columns: repeat(1, 1fr);
      }
    }

    .container-filter-outer.m-length {
      .filter-content {
        grid-template-columns: repeat(2, 1fr);
      }
    }

    .container-filter-outer.l-length {
      .filter-content {
        grid-template-columns: repeat(3, 1fr);
      }
    }

    .container-filter-outer.xl-length {
      .filter-content {
        grid-template-columns: repeat(4, 1fr);
      }
    }

     .container-filter-outer.xxl-length {
      .filter-content {
        grid-template-columns: repeat(5, 1fr);
      }
    }

    .container-filter-outer.has-content {
      @media (min-width: 1024px) {
        &:nth-child(1) {
          width: calc((((100% - (16px * 2)) / 3) * 2) + 16px);

          .filter-content {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        &:nth-child(2) {
          width: calc(((100% - (16px * 2)) / 3));
        }
      }

      @media (min-width: 1200px) {
         &:nth-child(1) {
          width: calc((((100% - (16px * 4)) / 5) * 4) + (16px * 3));

          .filter-content {
            grid-template-columns: repeat(4, 1fr);
          }
        }

        &:nth-child(2) {
          width: calc(((100% - (16px * 4)) / 5));
        }
      }
    }


    @media (min-width: 1024px) {
      flex-direction: row;
      align-items: start;
    }
  }
</style>
